import React,{useState} from "react";
import { Box, IconButton, Stack } from "@chakra-ui/react";
import {  getDay } from "date-fns";

import LabledDatePicker from "../common/LabeledDatePicker";
import { AiOutlineFileSearch } from "react-icons/ai";


function DateRangeSelectorForWeeklyView(props) {
    const [startDate, setStartDate] = useState(props.startDate);
    const [endDate, setEndDate] = useState(props.endDate);
    const [validationErrors, setValidationErrors] = useState({startDate: "", endDate: "" });

    const handleSubmit = () => {
        if (!startDate || !endDate) {
          if (!startDate)
            setValidationErrors((prev) => {
              return { ...prev, startDate: "Start date required.!" };
            });
          if (!endDate)
            setValidationErrors((prev) => {
              return { ...prev, endDate: "End date required.!" };
            });
          return;
        }
        if (startDate > endDate) {
          setValidationErrors((prev) => {
            return { ...prev, endDate: "End date mustbe less than start date!" };
          });
          setEndDate(null);
        }
        if(props.hasOwnProperty('handleSubmit'))
            props.handleSubmit(startDate, endDate);
      };

  return (
    <Stack direction="row" p={2} pr={4}>
      <Box>
        <LabledDatePicker
          validationClass={
            validationErrors.startDate ? "inputValidationError" : ""
          }
          label="File start date"
          selected={startDate}
          onChange={(date) => {
            if (startDate > endDate) {
              setEndDate(null);
            }
            setValidationErrors((prev) => {
              return {
                ...prev,
                startDate: null,
              };
            });
            setStartDate(date);
          }}
          filterDate={(date) => getDay(date) === 1}
        />
      </Box>
      <Box>
        <LabledDatePicker
          validationClass={
            validationErrors.endDate ? "inputValidationError" : ""
          }
          label="File end date"
          selected={endDate}
          minDate={startDate}
          onChange={(date) => {
            setValidationErrors((prev) => {
              return {
                ...prev,
                endDate: null,
              };
            });
            setEndDate(date);
          }}
          filterDate={(date) => getDay(date) === 0}
        />
      </Box>
      <Box>
        <IconButton
          size="md"
          aria-label="Search"
          onClick={handleSubmit}
          borderWidth={"1px"}
          borderColor={"rgb(94,94,114,.3)"}
          icon={<AiOutlineFileSearch />}
        />
      </Box>
    </Stack>
  );
}

export default DateRangeSelectorForWeeklyView;
